var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PerformanceTable',{attrs:{"label":_vm.label,"report-data":_vm.responseData,"dimension":_vm.dimension,"loading":_vm.isLoading,"hide-connections":true,"paginated":true,"show-link-to-detail":true,"per-page":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }